const ROUTES = {
	SIGN_UP: '/signup',
	LOGIN: '/login',
	FORGOT_PASSWORD: '/forgot-password',
	HOME: '/home',
	SERVICE_METRICS: '/services/:servicename',
	SERVICE_TOP_LEVEL_OPERATIONS: '/services/:servicename/top-level-operations',
	SERVICE_MAP: '/service-map',
	TRACE: '/trace',
	TRACE_DETAIL: '/trace/:id',
	TRACE_DETAIL_OLD: '/trace-old/:id',
	TRACES_EXPLORER: '/traces-explorer',
	ONBOARDING: '/onboarding',
	GET_STARTED_WITH_CLOUD: '/get-started-with-signoz-cloud',
	USAGE_EXPLORER: '/usage-explorer',
	APPLICATION: '/services',
	ALL_DASHBOARD: '/dashboard',
	DASHBOARD: '/dashboard/:dashboardId',
	DASHBOARD_WIDGET: '/dashboard/:dashboardId/:widgetId',
	DASHBOARD_PANEL_EDITOR: '/dashboard/:dashboardId/panel/:panelId',
	EDIT_ALERTS: '/alerts/edit',
	LIST_ALL_ALERT: '/alerts',
	ALERTS_NEW: '/alerts/new',
	ALERT_HISTORY: '/alerts/history',
	ALERT_OVERVIEW: '/alerts/overview',
	// TODO(H4ad): Add test to forbidden ? in this map after https://github.com/SigNoz/engineering-pod/issues/5322
	ALL_CHANNELS: '/alerts?tab=Channels',
	CHANNELS_NEW: '/alerts/channels/new',
	CHANNELS_EDIT: '/alerts/channels/edit/:channelId',
	ALL_ERROR: '/exceptions',
	ERROR_DETAIL: '/error-detail',
	VERSION: '/status',
	SETTINGS: '/settings',
	MY_SETTINGS: '/settings/my-settings',
	ORG_SETTINGS: '/settings/org-settings',
	INGESTION_SETTINGS: '/settings/ingestion-settings',
	SOMETHING_WENT_WRONG: '/something-went-wrong',
	UN_AUTHORIZED: '/un-authorized',
	NOT_FOUND: '/not-found',
	LOGS_BASE: '/logs',
	LOGS: '/logs/logs-explorer',
	OLD_LOGS_EXPLORER: '/logs/old-logs-explorer',
	LOGS_EXPLORER: '/logs/logs-explorer',
	LIVE_LOGS: '/logs/logs-explorer/live',
	LOGS_PIPELINES: '/logs/pipelines',
	PASSWORD_RESET: '/password-reset',
	LIST_LICENSES: '/licenses',
	LOGS_INDEX_FIELDS: '/logs-explorer/index-fields',
	TRACE_EXPLORER: '/trace-explorer',
	BILLING: '/settings/billing',
	ROLES_SETTINGS: '/settings/roles',
	ROLE_CREATE: '/settings/roles/new',
	ROLE_DETAILS: '/settings/roles/:roleId',
	ROLE_EDIT: '/settings/roles/:roleId/edit',
	MEMBERS_SETTINGS: '/settings/members',
	SUPPORT: '/support',
	LOGS_SAVE_VIEWS: '/logs/saved-views',
	TRACES_SAVE_VIEWS: '/traces/saved-views',
	TRACES_FUNNELS: '/traces/funnels',
	TRACES_FUNNELS_DETAIL: '/traces/funnels/:funnelId',
	WORKSPACE_LOCKED: '/workspace-locked',
	WORKSPACE_SUSPENDED: '/workspace-suspended',
	SHORTCUTS: '/settings/shortcuts',
	INTEGRATIONS: '/integrations',
	INTEGRATIONS_DETAIL: '/integrations/:integrationId',
	MESSAGING_QUEUES_BASE: '/messaging-queues',
	MESSAGING_QUEUES_KAFKA: '/messaging-queues/kafka',
	MESSAGING_QUEUES_KAFKA_DETAIL: '/messaging-queues/kafka/detail',
	INFRASTRUCTURE_MONITORING_BASE: '/infrastructure-monitoring',
	INFRASTRUCTURE_MONITORING_HOSTS: '/infrastructure-monitoring/hosts',
	INFRASTRUCTURE_MONITORING_KUBERNETES: '/infrastructure-monitoring/kubernetes',
	MESSAGING_QUEUES_CELERY_TASK: '/messaging-queues/celery-task',
	MESSAGING_QUEUES_OVERVIEW: '/messaging-queues/overview',
	METRICS_EXPLORER: '/metrics-explorer/summary',
	METRICS_EXPLORER_EXPLORER: '/metrics-explorer/explorer',
	METRICS_EXPLORER_VIEWS: '/metrics-explorer/views',
	METRICS_EXPLORER_VOLUME_CONTROL: '/metrics-explorer/volume-control',
	API_MONITORING_BASE: '/api-monitoring',
	API_MONITORING: '/api-monitoring/explorer',
	METRICS_EXPLORER_BASE: '/metrics-explorer',
	WORKSPACE_ACCESS_RESTRICTED: '/workspace-access-restricted',
	METER: '/meter',
	METER_EXPLORER: '/meter/explorer',
	METER_EXPLORER_VIEWS: '/meter/explorer/views',
	HOME_PAGE: '/',
	PUBLIC_DASHBOARD: '/public/dashboard/:dashboardId',
	SERVICE_ACCOUNTS_SETTINGS: '/settings/service-accounts',
	AI_ASSISTANT: '/ai-assistant/:conversationId',
	AI_ASSISTANT_BASE: '/ai-assistant',
	AI_ASSISTANT_ICON_PREVIEW: '/ai-assistant-icon-preview',
	MCP_SERVER: '/settings/mcp-server',
	LLM_OBSERVABILITY_BASE: '/llm-observability',
	LLM_OBSERVABILITY_OVERVIEW: '/llm-observability/overview',
	LLM_OBSERVABILITY_CONFIGURATION: '/llm-observability/configuration',
} as const;

export default ROUTES;
